<div class="detailed-entity-card">
    <div class="entity-card-header justify-content-between">
        <div class="entity-icon">
            <img width="48" height="48" src="assets/svg/Fan.svg"/>
        </div>
        <div class="entity-details">
            <h2 class="entity-name">{{ equipmentDetails?.label }}</h2>
            <p class="entity-class">{{ equipmentDetails?.objectClassLabel }}</p>
        </div>
        @if (equipmentDetails?.pinned) {
            <eon-ui-icon
                class="top-right-position cursor-pointer"
                name="bookmark"
                (click)="togglePin($event, equipmentDetails)"
            ></eon-ui-icon>
        } @else {
            <eon-ui-icon
                class="top-right-position cursor-pointer"
                name="bookmark_outline"
                (click)="togglePin($event, equipmentDetails)"
            ></eon-ui-icon>
        }
    </div>
    <div class="entity-card-header justify-content-between">
        <div class="entity-details">
            <h2 class="entity-name"><b>Data Point Relationships</b></h2>
        </div>
    </div>
    <div class="entity-card-content">
        <div class="entity-top-details">
            <p>
                <b>Physical Location:</b>&nbsp;
                @if (equipmentDetails?.locationLabel) {
                    <a
                        href=""
                        [routerLink]="['/locations', equipmentDetails?.locationId]"
                    >{{ equipmentDetails?.locationLabel }}</a>
                } @else {
                    <span>N/A</span>
                }
            </p>
            <p>
                <b>Sub Equipment:</b> &nbsp;
                @if (equipmentDetails?.hasPartRelationsList?.length) {
                    @for (item of equipmentDetails?.hasPartRelationsList; track $index) {
                        <span>{{ item?.name }}</span>
                    }
                } @else {
                    <span>N/A</span>
                }
            </p>
            <p>
                <b>Feeds Location:</b>&nbsp;
                @if (equipmentDetails?.feedsLocationList?.length) {
                    @for (item of equipmentDetails?.feedsLocationList; track $index) {
                        <a
                            href=""
                            [routerLink]="['/locations', item?.id]"
                        >{{ item?.name }}</a>
                    }
                } @else {
                    <span>N/A</span>
                }
            </p>
            <p>
                <b>Feeds Equipment:</b>&nbsp;
                @if (equipmentDetails?.feedsEquipmentList?.length) {
                    @for (item of equipmentDetails?.feedsEquipmentList; track $index) {
                        <a
                            href=""
                            [routerLink]="['/equipments', item?.id]"
                        >{{ item?.name }}</a>
                    }
                } @else {
                    <span>N/A</span>
                }
            </p>
        </div>
    </div>

    <div class="entity-card-content p-0">
        <cc-smart-alerts [alerts]="equipmentDetails?.smartAlerts"></cc-smart-alerts>
    </div>

    @if (equipmentDetails?.sensorsAndStatusDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Sensors & Status</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points
                [points]="equipmentDetails?.sensorsAndStatusDatapointsList"
                [pointsStatus]="pointsStatus"
            ></cc-entity-points>
        </div>
    }

    @if (equipmentDetails?.alarmsDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Alarms</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points
                [points]="equipmentDetails?.alarmsDatapointsList"
                [pointsStatus]="pointsStatus"
            ></cc-entity-points>
        </div>
    }

    @if (equipmentDetails?.commandsDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Commands</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points
                [points]="equipmentDetails?.commandsDatapointsList"
                [pointsStatus]="pointsStatus"
            ></cc-entity-points>
        </div>
    }
    @if (equipmentDetails?.setpointsAndParametersDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Setpoints & Parameters</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points
                [points]="equipmentDetails?.setpointsAndParametersDatapointsList"
                [pointsStatus]="pointsStatus"
            ></cc-entity-points>
        </div>
    }
    @if (equipmentDetails?.schedulesList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Schedules</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            @for (schedule of equipmentDetails?.schedulesList; track $index) {
                <div class="entity-row">
                    <div class="first-col">
                        <span>{{ schedule?.comment || schedule?.classLabel }}</span>
                    </div>
                    <div
                        class="mid-col flex align-items-center justify-content-end margin-left-auto"
                    >
                        <span>{{ schedule?.presentValue }}</span>
                        <span class="icon-btn">
                            <img
                                class="cursor-pointer"
                                src="assets/icons/exception.svg"
                                (click)="showExceptionSchedule(schedule?.pointUUID)"
                            />
                        </span>
                        <span class="icon-btn">
                            <img
                                class="cursor-pointer"
                                src="assets/icons/schedule.svg"
                                (click)="showSchedule(schedule?.pointUUID)"
                            />
                        </span>
                    </div>
                </div>
            }
        </div>
    }
    <div
        class="entity-card-footer flex align-items-center justify-content-between"
    >
        <eon-ui-icon
            name="more"
            aria-label="more"
            class="hydrated"
        ></eon-ui-icon>
        @if (equipmentLink) {
            <cc-share-link
                [link]="equipmentLink"
            ></cc-share-link>
        }
    </div>
</div>

@if (showScheduleDialog) {
    <p-dialog
        header="Weekly Schedule"
        [(visible)]="showScheduleDialog"
        [modal]="true"
        [breakpoints]="{ '640px': '90vw' }"
        [style]="{ width: '90vw', height: '95%' }"
    >
        @if (showScheduleDialog) {
            <cc-schedule-calendar
                [scheduleUUID]="selectedScheduleUUID"
            ></cc-schedule-calendar>
        }
    </p-dialog>
}

@if (showExceptionScheduleDialog) {
    <p-dialog
        header="Exception Schedule"
        [(visible)]="showExceptionScheduleDialog"
        [modal]="true"
        [breakpoints]="{ '640px': '90vw' }"
        [style]="{ width: '90vw', height: '95%' }"
    >
        @if (showExceptionScheduleDialog) {
            <cc-exception-schedule-table
                [exceptionScheduleUUID]="selectedExceptionScheduleUUID"
            ></cc-exception-schedule-table>
        }
    </p-dialog>
}
